export const appConfig = {
  defaultPagingSize: 8
};
